import {Flex, Typography} from 'antd';
import React, {useState} from 'react';

import {useAdminAllUsersQuery} from '../../../gen/api/apis';
import {AdminUser} from '../../../gen/api/models';
import {useScreenInfo} from '../../../ResponsiveGate';
import {ChangePasswordDialog} from './components/ChangePasswordDialog';
import {CreateUserDialog} from './components/CreateUserDialog';
import {Users} from './components/Users';

const {Title} = Typography;

export const UserPage: React.FC = () => {
    const {screenMap} = useScreenInfo();
    const [users, setUsers] = useState<AdminUser[]>([]);

    const userQuery = useAdminAllUsersQuery({
        onSuccess: (data) => {
            setUsers(data);
        },
        refetchOnMount: 'always',
    });

    return (
        <div>
            <Flex
                justify="space-between"
                align="center"
                style={{marginBottom: 16}}
            >
                <Flex align="center">
                    <Title
                        level={screenMap.lg ? 3 : 5}
                        style={{margin: '0 10px 0 0'}}
                    >
                        User Page
                    </Title>
                    <CreateUserDialog onCreated={() => userQuery.refetch()} />
                </Flex>
                <ChangePasswordDialog />
            </Flex>
            <Users
                users={users}
                loading={userQuery.isLoading}
            />
        </div>
    );
};
